import React from 'react';

export interface TokenDef { token: string; desc: string; }

/** Barre de jetons {{...}} cliquables — insère le jeton à la position du curseur dans le textarea associé
 *  au lieu de se contenter de l'afficher, pour éviter d'avoir à le retaper à la main. */
export function TokenPicker({
    tokens,
    textareaRef,
    value,
    onChange,
}: {
    tokens: TokenDef[];
    textareaRef: React.RefObject<HTMLTextAreaElement | null>;
    value: string;
    onChange: (v: string) => void;
}) {
    const insert = (token: string) => {
        const el = textareaRef.current;
        if (!el) { onChange(value + token); return; }
        const start = el.selectionStart ?? value.length;
        const end = el.selectionEnd ?? value.length;
        const next = value.slice(0, start) + token + value.slice(end);
        onChange(next);
        requestAnimationFrame(() => {
            el.focus();
            const pos = start + token.length;
            el.setSelectionRange(pos, pos);
        });
    };

    return (
        <div className="flex flex-wrap gap-1.5">
            {tokens.map((t) => (
                <button
                    key={t.token}
                    type="button"
                    title={t.desc}
                    onClick={() => insert(t.token)}
                    className="px-2 py-1 rounded-lg bg-surface-soft border border-border text-[10px] font-mono text-content-muted hover:text-brand-600 dark:hover:text-brand-400 hover:border-brand-500 hover:bg-brand-500/10 transition-all cursor-pointer"
                >
                    {t.token}
                </button>
            ))}
        </div>
    );
}
